import counterpart from 'counterpart';

const strings = {
  activationOperation: {
    error: 'Virhe',
    viewActivation: 'Tarkastele aktivointia',
  },
  activationOperations: {
    archive: {
      confirmMessage: {
        one: 'Haluatko varmasti arkistoida tämän kohteen?',
        other: 'Haluatko varmasti arkistoida nämä %(count)s kohdetta?',
      },
      failure: {
        one: 'Arkistointi ei onnistunut seuraavassa kohteessa',
        other: 'Arkistointi ei onnistunut seuraavissa %(count)s kohteessa ',
      },
      success: 'Kohteet arkistoitu',
      progressMessage: 'Arkistoidaan kohteita',
      title: 'Arkistoi kohteita',
    },
    cancelEvents: {
      cancelAll: 'Peru kaikki',
      cancelByDate: 'Peru päivämäärän perusteella',
      cancelEvents: 'Peru arviointikerrat',
      cancelFrom: 'Alkupvm.',
      cancelTo: 'Loppupvm.',
      chooseEventsToCancel: 'Valitse peruttavat arviointikerrat',
      failure: {
        one: 'Arviointikertojen peruminen ei onnistunut seuraavassa kohteessa',
        other: 'Arviointikertojen peruminen ei onnistunut seuraavissa %(count)s kohteessa ',
      },
      progressMessage: 'Perutaan arviointikertoja',
      success: 'Arviointikerrat peruttu',
      title: 'Peru arviointikertoja',
      unFinishedEventDates: 'Suorittamattomat arviointikerrat',
    },
    createEvents: {
      createEvents: 'Lisää arviointikerrat',
      conflictingEvents: {
        one: 'Yhdellä kohteella on jo arviointikerta päivälle %(date)s. Päällekkäisiä arviointikertoja ei luoda.',
        other: '%(count)s kohteella on jo arviointikerta päivälle %(date)s. Päällekkäisiä arviointikertoja ei luoda.',
      },
      datesToAdd: 'Lisättävät arviointikerrat',
      failure: {
        one: 'Arviointikertojen luominen ei onnistunut seuraavassa kohteessa',
        other: 'Arviointikertojen luominen ei onnistunut seuraavissa %(count)s kohteessa ',
      },
      progressMessage: 'Luodaan arviointikertoja',
      success: 'Arviointikerrat luotu',
      title: 'Lisää arviointikertoja',
      unFinishedEventDates: 'Suorittamattomat arviointikerrat',
    },
    modifyParties: {
      addParty: 'Lisää henkilö',
      chooseAction: 'Valitse toiminto',
      failure: 'Joidenkin kohteiden muokkaus epäonnistui',
      parties: 'Henkilöt',
      partyReplacement: 'Tilalle tuleva henkilö',
      partyRole: 'Henkilön rooli',
      partyShouldNotReplaceItself: 'Henkilöä ei saa korvata itsellään',
      partyToAdd: 'Lisättävä henkilö',
      partyToRemove: 'Poistettava henkilö',
      partyToReplace: 'Vaihdettava henkilö',
      progressMessage: 'Muokataan henkilötietoja',
      removeParty: 'Poista henkilö',
      replaceParty: 'Korvaa henkilö',
      submitText: 'Suorita muutokset',
      success: 'Henkilötiedot päivitetty onnistuneesti',
      title: 'Muokkaa kohteeseen liitettyjä henkilöitä',
    },
    modifyRecurrences: {
      confirmMessage: '',
      failure: {
        one: 'Arviointisyklin muokkaaminen ei onnistunut seuraavassa kohteessa',
        other: 'Arviointisyklien muokkaaminen ei onnistunut seuraavissa %(count)s kohteessa ',
      },
      isPermanentAndBad: 'HUOM! Syklin muokkaaminen peruu kaikki olemassa olevat tekemättömät arvioinnit ja luo niiden tilalle uudet',
      proceedText: 'Muokkaa arviointisyklejä valituille aktivoinneille',
      progressMessage: 'Muokataan arviointisyklejä',
      success: 'Arviointisyklit muokattu',
      title: 'Muokkaa arviointisyklejä',
    },
  },
  activationEditor: {
    actions: 'Toimenpiteet',
    activationNotFound: 'Arviointikohdetta ei löytynyt',
    activationPartyType: 'Henkilön rooli',
    activationState: 'Arviointikohteen tila',
    active: 'Aktiivinen',
    addLocation: 'Lisää kohteen tarkenne',
    addParty: 'Lisää henkilö',
    address: 'Osoite',
    archive: 'Arkistoi arviointikohde',
    archived: 'Arkistoitu',
    archiveModalTitle: 'Arviointikohteen arkistointi',
    archivingIsPermanentAndBad: 'Arviointikohteen arkistointi poistaa kaikki tekemättömät arviointikerrat, eikä sitä voi perua.',
    restore: 'Palauta arviointikohde',
    restoreTitle: 'Arviointikohteen palautus',
    restoringConfirmation: 'Haluatko palauttaa arviointikohteen (poistetuksi merkittyjä tapahtumia ei muuteta)?',
    companyName: 'Yritys',
    confirmOwnPartyRemoval: 'Haluatko varmasti poistaa itsesi arviointikohteen henkilöistä?',
    deleteLocation: 'Poista tarkenne',
    downloadPdfReport: 'Lataa PDF-raportti',
    doYouWantToArchive: 'Arkistoidaanko arviointikohde?',
    editActivation: 'Muokkaa aktivointia',
    editLocation: 'Muokkaa tarkennetta',
    editRecurrence: 'Muokkaa arviointisykliä',
    editRecurrenceWarning: 'HUOM! Syklin muokkaaminen peruu kaikki olemassa olevat tekemättömät arvioinnit ja luo niiden tilalle uudet',
    events: 'Arvioinnit',
    finishedDate: 'Arvioinnin suorituspäivämäärä',
    formName: 'Arviointipohja',
    hide: {
      true: 'Piilotettu',
      false: 'Näkyvillä',
    },
    hideLogoOnReport: 'ISS:n logon näkyvyys raportilla',
    sendReports: {
      true: 'Käytössä',
      false: 'Ei käytössä',
    },
    sendPdfReport: 'PDF-raporttien lähetys',
    locationAddress: 'Tarkempi osoite',
    locationName: 'Tarkenne',
    newEvent: 'Luo arviointikerta',
    partyHasNoEmail: 'Sähköposti puuttuu, henkilölle ei voida lähettää raporttia',
    plannedDate: 'Suunniteltu päivämäärä',
    recurrenceDays: 'Arviointisyklin toteuspäivät',
    recurrenceDetails: 'Arviointisyklin tiedot',
    recurrenceType: 'Arviointisyklin toteutustapa',
    removeParty: 'Poista henkilö',
    responsibleParties: 'Aktivointiin liitetyt henkilöt',
    service: 'Arvioitu palvelu',
    phaseShouldBeDoneInMobile: 'Vaihe tulee kuitata mobiilissa',
    state: 'Arvioinnin tila',
    contractInfo: 'Arviointikohteen tiedot',
    title: 'Aktivoinnin hallinta'
  },
  activationList: {
    activationId: 'Tunnus',
    activationContract: 'Aktivoinnin kohde',
    adminTitle: 'Kaikki vastuukohteet',
    archived: 'Arkistoitu',
    editActivation: 'Muokkaa aktivointia',
    editSelected: 'Muokkaa valittuja kohteita',
    formName: 'Lomake',
    lateEventsCount: 'Myöhässä',
    latestEvent: 'Viimeisin kierros',
    nextEventDate: 'Seuraava kierros',
    ownActivations: 'Omat vastuukohteet',
    recurrenceType: 'Arviointisykli',
    showArchived: 'Näytä arkistoidut',
    siteAddress: 'Osoite',
    siteLocationName: 'Tarkenne',
    siteName: 'Nimi',
    siteNameAndAddress: 'Nimi ja osoite',
    title: 'Omat vastuukohteet',
  },
  appStoreLinksPage: {
    title: 'Lataa LuurISSa-sovellus sovelluskaupastasi'
  },
  batchEvaluationActivator: {
    activationFailed: 'Aktivointi epäonnistui',
    activationModalTitle: 'Kohteiden aktivointi',
    activationPartyType: 'Henkilön tyyppi',
    activationSuccess: 'Aktivointi valmis',
    addLocation: 'Lisää tarkenne',
    addToSelected: 'Lisää henkilö valittuihin kohteisiin',
    alreadyActivated: 'kohde jo aktivoitu',
    changeActivationSettings: 'Muuta kohteiden aktivointiasetuksia',
    clearSelected: 'Tyhjennä valitut kohteet',
    clearSelectedDates: 'Tyhjennä valitut',
    doYouWantToRetryFailedActivations: 'Haluatko yrittää aktivointia uudestaan kohteille, joiden aktivointi epäonnistui?',
    hideLogoOnReport: 'Piilota ISS:n logo raportilta kaikilla aktivoitavilla kohteilla',
    sendPdfReport: 'Lähetä PDF-raportti kaikilla aktivoitavilla kohteilla',
    menuTitle: 'Arviointien aktivointi',
    needsToHaveSiteCoordinators: 'Jokaisella kohteella pitää olla ainakin yksi vastuuhenkilö',
    newActivation: 'Tee uusi aktivointi',
    party: 'Henkilö',
    personIsAlreadyAdded: 'Valitsemasi henkilö(t) on jo lisätty jollekin valitsemistasi kohteista',
    profitCenters: 'Tulosyksiköt',
    recurrenceDateHelpText: 'Voit aktivoida vain yhdellä arviointisyklillä kerrallaan, uuden syklin valinta tyhjentää päivämäärät',
    retryActivation: 'Yritä aktivointia uudelleen',
    seeActivationList: 'Tarkastele tehtyjä aktivointeja',
    sendingActivations: {
      one: 'Aktivoidaan yhtä kohdetta',
      other: 'Aktivoidaan %(count)s kohdetta',
    },
    setSelectedDates: 'Aseta päivät valittuihin',
    splitContract: 'Tarkenna/pilko kohde',
    contractChooserSectionTitle: 'Kohteet',
    contractSelectorExternalIdHelp: 'Voit syöttää hakuun myös listan sopimusnumeroita muodossa 1234567, 9876543, 2345678',
    theseContractActivationsFailed: {
      one: 'Yhden kohteen aktivoinnissa tapahtui virhe',
      other: 'Seuraavien %(count)s kohteen aktivoinnissa tapahtui virhe',
    },
    title: 'Aktivoi arviointikohteita',
    whollyNewActivation: 'Tee kokonaan uusi aktivointi',
  },
  common: {
    add: 'Lisää',
    batchOpInProgress: 'Tietojen lähetys palvelimelle on kesken. Haluatko varmasti poistua sivulta?',
    cancel: 'Peruuta',
    clearSelection: 'Tyhjennä valinta',
    close: 'Sulje',
    create: 'Luo',
    deletedSuccessfully: 'Poistettu onnistuneesti',
    edit: 'Muokkaa',
    editOrView: 'Tarkastele',
    genericLoadError: 'Tietojen lataamisessa tapahtui virhe',
    genericSaveError: 'Tallentaminen epäonnistui',
    message: 'Viesti',
    nextSection: 'Seuraava',
    noItemsFound: 'Hakuehdoilla ei löytynyt kohteita',
    remove: 'Poista',
    removedSuccessfully: 'Poisto onnistui',
    save: 'Tallenna',
    savedSuccessfully: 'Tallennus onnistui',
    search: 'Hae',
    searchResultsCount: {
      zero: 'Hakusanoilla ei löytynyt yhtään kohdetta',
      one: 'Löytyi 1 kohde.',
      other: 'Löytyi %(count)s kohdetta.',
    },
    searchResultsShown: 'Näytetään %(count)s yhteensä %(total)s kohteesta. Vieritä alaspäin ladataksesi lisää kohteita.',
    selectAll: 'Valitse kaikki',
    selectedCount: {
      zero: 'Ei valittuja kohteita',
      one: 'Valittu 1 kohde',
      other: 'Valittu %(count)s kohdetta',
    },
    selected: 'Valittu',
    selectPlaceholder: 'Valitse...',
    shortWeekDays: ['ma', 'ti', 'ke', 'to', 'pe', 'la', 'su'],
    showAllResults: 'Näytä kaikki hakutulokset',
  },
  contractSuppliers: {
    title: 'Sopimustoimittajat',
    id: 'Tunniste',
    name: 'Nimi',
    description: 'Kuvaus',
    serviceInformation: 'Tiedot palvelusta',
    otherInformation: 'Muut tiedot',
    area: 'Alue',
    category: 'Hankintakategoria',
    preferredSupplier: 'Preferoitu toimittaja',
    deleted: 'Poistettu',
    newContractSupplier: 'Uusi sopimustoimittaja',
    editContractSuppliersTooltip: 'Muokkaa sopimustoimittajaa',
    yes: 'Kyllä',
    showOnlyPreferred: 'Näytä vain preferoidut',
    reviewAverage: 'Arvosanojen keskiarvo',
    noReviewAverage: 'Toimittajaa ei ole arvioitu viimeisen vuoden aikana'
  },
  contractSupplierEditor: {
    editTitle: 'Muokkaa sopimustoimittajan tietoja',
    newTitle: 'Uusi sopimustoimittaja',
    returnToList: 'Takaisin sopimustoimittajiin',
    supplierNotFound: 'Sopimustoimittajaa ei löytynyt',
    deleteSupplier: 'Poista sopimustoimittaja',
    doYouWantToDelete: 'Haluatko varmasti poistaa sopimustoimittajan',
    delete: 'Poista',
    deleted: 'Poistettu sopimustoimittaja',
    reviews: 'Tarkastele arvosteluja',
    newReview: 'Arvioi',
  },
  contractSupplierReviews: {
    title: 'Sopimustoimittajan arvostelut',
    returnToEditor: 'Takaisin sopimustoimittajaan',
  },
  contractSupplierReviewEditor: {
    newTitle: 'Uusi arvio',
    modifyTitle: 'Muokkaa arviota',
    contractSupplier: 'Sopimustoimittaja',
    returnToSupplier: 'Takaisin sopimustoimittajaan'
  },
  counterpart: {
    names: require('date-names/fi'),
    pluralize: require('pluralizers/en'),
  },
  domain: {
    activatedEvaluation: {
      evaluationType: 'Arviointitapa',
      evaluationTypes: {
        REGULAR_EVALUATION: 'Tavallinen yksivaiheinen arviointi',
        TWO_PHASED_EVALUATION: 'Korjaavien toimenpiteiden seuranta (Kaksivaiheinen arviointi)',
        FOUR_PHASED_EVALUATION: 'Vaiheistettu arviointi',
      },
      location: {
        address: 'Tarkempi osoite',
        city: 'Kaupunki',
        code: 'Tarkenteen tunniste',
        name: 'Tarkenteen nimi',
        shouldHaveAddressWhenCityIsGiven: 'Tarkenteelle on syötettävä osoite, kun kaupunki on annettu',
        shouldHaveCityWhenAddressISGiven: 'Tarkenteelle on syötettävä kaupunki, kun osoite on annettu',
      },
      partyActivationTypes: {
        INFORMANT: 'Laaturaportti tiedoksi',
        SITE_COORDINATOR: 'Laadunarviointeja tekevät',
      },
      recurrenceTypes: {
        CUSTOM_DATES: 'Mukautetut päivämäärät',
        MANUAL: 'Manuaalinen',
        MONTHLY: 'Kuukausittain',
        WEEKLY: 'Viikoittain',
      },
    },
    answerVisibility: {
      EVALUATOR_ONLY: 'Vain arvioinnin tekijä',
      EVALUATOR_AND_SUBJECT: 'Arvioinnin tekijä ja arvioinnin kohde',
    },
    contractSupplier: {
      businessId: 'Y-tunnus',
      name: 'Toimittajan nimi',
      description: 'Kuvaus',
      serviceInformation: 'Tiedot palvelusta',
      otherInformation: 'Muut tiedot',
      contactPerson: 'Yhteyshenkilö',
      email: 'Sähköpostiosoite',
      area: 'Alue',
      preferredSupplier: 'Preferoitu toimittaja',
      category: 'Hankintakategoria,'
    },
    contractSupplierReview: {
      grade: 'Arvosana',
      additionalInformation: 'Lisätiedot',
      party: 'Käyttäjä',
      created: 'Arvioitu'
    },
    evaluationEvent: {
      activationId: 'Aktivointitunnus',
      eventActions: {
        fillEvaluation: 'Täytä arviointilomake',
        fillCorrectionalRemarks: 'Täytä korjaavat toimenpiteet',
        markSelfMonitoringDone: 'Merkitse omavalvonta tehdyksi',
        reviewCorrectiveActions: 'Katselmoi korjaavat toimenpiteet',
        startEvaluation: 'Aloita arviointi',
      },
      eventCancelReasons: {
        chooseCancellingReason: 'Valitse perumisen syy',
        CONTRACT_ENDED: 'Kohteen palvelusopimus päättynyt',
        INTERNAL_REASON: 'ISS:n sisäinen syy, esim. resurssivaje',
        NOT_MY_RESPONSIBILITY: 'Kohde ei ole vastuullani',
        TEMPORARILY_CLOSED: 'Kohde väliaikaisesti suljettu tai remontissa',
        OTHER_REASON: 'Muu syy (tarkenna alle)',
      },
      eventId: 'Arviointitunnus',
      eventStates: {
        CANCELLED: 'Peruttu',
        DELETED: 'Poistettu',
        FINISHED: 'Suoritettu',
        READY_FOR_CORRECTIONAL_REMARKS: 'Odottaa korjaavien toimenpiteiden merkitsemistä',
        READY_FOR_EVALUATION: 'Valmis arvioitavaksi',
        ANSWERS_DELETED: 'Vastaukset poistettu',
        STARTED: 'Aloitettu',
        SELF_MONITORING: 'Omavalvonta',
        READY_FOR_REVIEW: 'Valmis katselmoitavaksi',
        null: 'Tieto puuttuu',
      },
      formName: 'Lomake',
      plannedDate: 'Suunniteltu ajankohta',
      state: 'Arvioinnin tila',
      site: 'Aktivointikohde',
      siteCoordinator: 'Vastuuhenkilö'
    },
    evaluationForm: {
      activationReportingStyle: {
        GRADE_AVERAGE: 'Arvosanojen keskiarvo',
        SUCCESS_PERCENTAGE: 'Onnistumisprosentti',
        QUALITY_PERCENTAGE: 'Laatuprosentti',
      },
      name: 'Nimi',
      description: 'Lisätiedot',
      gradingScaleName: 'Asteikko',
      siteSizes: {
        FROM_500_TO_1200: '500 - 1200 m²',
        OVER_1200: 'Yli 1200 m²',
        UNDER_500: 'Alle 500 m²',
        null: 'Mikä tahansa koko',
      },
    },
    formEvaluationContext: {
      QUALITY_ASSURANCE: 'Laadunseurantalomakkeet',
      WORK_SECURITY: 'Työturvallisuuslomakkeet',
      OTHER: 'Muut lomakkeet',
      NOT_IN_USE: 'Ei ole käytettävissä henkilöarvioinneissa',
    },
    question: {
      formName: 'Lomake',
      headingTitle: 'Otsikko',
      description: 'Kysymyksen lisätiedot',
      groups: 'Kysymysluokat',
      id: 'Tunniste',
      name: 'Kysymys',
    },
    questionGroup: {
      groupDescription: 'Kysymysluokka',
    },
    subsystemType: {
      ALL_SYSTEMS: 'Koko järjestelmä',
      GENERAL_INTERNAL_NOTIFICATION: 'Yleinen ilmoitus (vain ISS:n henkilökunnalle)',
      GENERAL_EXTERNAL_NOTIFICATION: 'Yleinen ilmoitus (vain ulkoisille käyttäjille)',
      GENERAL_NOTIFICATION: 'Yleinen ilmoitus',
      SITE_INFORMATION: 'Kohdekansio',
      ECOM: 'Ecom-lähetteet', // Not in use anymore
      QUALITY_EVALUATION: 'Laadunseuranta',
      SECURITY_OBSERVATIONS: 'Turvallisuushavainnot',
    },
    systemStatus: {
      DOWN: 'Vikatila',
      UP: 'Järjestelmä toimii normaalisti',
    }
  },
  // These texts are related to batchEvaluationActivator:
  evaluationActivator: {
    activate: 'Aktivoi',
    chooseEvaluationDates: 'Valitse arvioinnin syklin päivät',
    chooseProfitCenter: 'Valitse tulosyksikkö',
    createParty: 'Luo käyttäjä',
    evaluationDates: 'Arviointipäivämäärät',
    evaluationDays: 'Arviointipäivät',
    evaluationForm: 'Arviointipohja',
    evaluationSite: 'Kohde',
    formChooserSectionTitle: 'Arviointipohja',
    informants: 'Laaturaportti tiedoksi',
    lastWorkingDayOfMonth: 'Kuun viimeinen arkipäivä',
    profitCenter: 'Tulosyksikkö',
    recurrenceType: 'Arvioinnin sykli',
    responsiblePartiesSectionTitle: 'Aktivointiin liitettävät henkilöt',
    service: 'Palvelu',
    serviceType: 'Palvelutyyppi',
    serviceTypeSectionTitle: 'Palvelu',
    settingsSectionTitle: 'Arvioinnin asetukset',
    siteCoordinators: 'Laaturaportteja tekevät',
    siteExternalId: 'Sopimusnumero:',
    siteSize: 'Kohteen koko',
    weekendAvoidanceExplanation: 'Tätä arviointisykliä käytettäessä arvioinnit eivät koskaan sijoitu viikonlopuille. ' +
      'Viikonlopulle osuvat päivämäärät siirretään seuraavalle samassa kuussa olevalle arkipäivälle.',
  },
  evaluationFormOperations: {
    changeGradingScale: {
      chooseAimedGrade: 'Valitse tavoitearvosana',
      confirmMessage: {
        one: 'Haluatko varmasti vaihtaa arviointiasteikon tälle lomakkeelle?',
        other: 'Haluatko varmasti vaihtaa arviointiasteikon näille %(count)s lomakkeelle?',
      },
      failure: {
        one: 'Arviointiasteikon vaihto ei onnistunut seuraavalle lomakkeelle',
        other: 'Arviointiasteikon vaihto ei onnistunut seuraaville %(count)s lomakkeelle',
      },
      forms: 'Lomakkeet:',
      proceed: 'Vaihda arviointiasteikko',
      progressMessage: 'Vaihdetaan arviointiasteikkoa',
      success: 'Arviointiasteikko vaihdettu onnistuneesti',
      title: 'Vaihda arviointiasteikko valituille lomakkeille',
    },
  },
  eventEditor: {
    actions: 'Arvionnin muutokset',
    actionType: 'Muutos',
    activationId: 'Aktivointitunnus',
    cancelEvent: 'Peru arviointi',
    cancellingReasonDescription: 'Lisätietoja',
    cancellingReason: 'Perumisen syy',
    description: 'Kuvaus',
    editor: 'Muutoksen tekijä',
    eventId: 'Arviointitunnus',
    eventInfo: 'Arvioinnin tiedot',
    eventNotFound: 'Arviointikertaa ei löytynyt',
    plannedDate: 'Suunniteltu ajankohta',
    reActivateEvent: {
      fromFINISHED: {
        REGULAR_EVALUATION: 'Palauta arvioitavaksi',
        TWO_PHASED_EVALUATION: 'Palauta korjaavien toimenpiteiden merkintään',
        FOUR_PHASED_EVALUATION: 'Palauta katselmoitavaksi',
      },
      fromREADY_FOR_REVIEW: 'Palauta korjaavien toimenpiteiden merkintään',
      fromREADY_FOR_CORRECTIONAL_REMARKS: 'Palauta arvioitavaksi',
    },
    reActivationReason: 'Palautuksen syy',
    state: 'Arvioinnin tila',
    site: 'Aktivointikohde',
    timestamp: 'Muutosaika',
    title: 'Muokkaa arviontikertaa',
  },
  extUserPasswordChangeHint: {
   title: 'Salasanasi täytyy vaihtaa',
   hint1: 'Salasanasi on vaihdettava. Voit vaihtaa sen',
   hint2: 'täällä',
  },
  fillEvaluationEditor: {
    additionalEventInfo: 'Lisätietoja arvioinnista',
    address: 'Kohteen osoite',
    aimedGrade: 'Tavoitearvosana',
    chooseHeading: 'Valitse otsikko',
    contactPerson: 'Yhdyshenkilö kierroksella',
    currentDate: 'Todellinen ajankohta',
    eventInfoClarification: 'Arviointitietojen tarkennus',
    nextHeading: 'Seuraava otsikko',
    plannedDate: 'Suunniteltu ajankohta',
    remarks1: 'Lisätiedot',
    remarks2: 'Vastuu',
    showGeneralInfo: 'Takaisin yleisiin tietoihin',
    stateError: 'Tämä vaihe on tarkoitettu täytettäväksi LuurISSa-mobiilisovelluksessa',
  },
  formEditor: {
    activationReportingStyle: 'Näytä raportilla',
    activationReportingStyleExplanation: {
      GRADE_AVERAGE: 'Raportilla näytetään annettujen arvosanojen numeroarvojen keskiarvo.',
      SUCCESS_PERCENTAGE: 'Raportilla näytetään prosentteina kuinka suuri osuus annetuista arvosanoista on tavoitearvosana.',
      QUALITY_PERCENTAGE: 'Raportilla näytetään annettujen arvosanojen laatuprosenttien keskiarvo. '+
      'Laatuprosentti lasketaan oletuksena siten, että pienimmällä arvosanalla se on 0%%, tavoitearvosanalla 100%% ja muut arvosanat skaalataan näiden mukaan. '+
      'Prosentteja voi myös erikseen säätää alta:',
    },
    aimedGrade: 'Tavoitearvosana',
    alternativeEventLogTitle: 'Muutoshistorian otsikko',
    alternativeEventLogTitleDefault: 'Arviointikerran muutoshistoria',
    alternativeQuestionTitle: 'Kysymyssarakkeen otsikko',
    alternativeQuestionTitleDefault: 'Arvioitu asia',
    alternativeReportTitle: 'Raportin otsikko',
    alternativeReportTitleDefault: 'Laadunseurantaraportti',
    answerVisibility: 'Arvioinnin vastausten näkyvyys henkilöarvioinneissa',
    chooseAimedGrade: 'Valitse tavoitearvosana',
    chooseHigherAimedGrade: 'Valitse toinen tavoitearvosana. Laatuprosenttia ei voida laskea, jos tavoitearvosana on pienin arvosana tai tavoitearvosanan numeroarvo on sama kuin pienimmän arvosanan.',
    editTitle: 'Muokkaa arviointipohjaa',
    excelUpload: {
      fileInput: 'Ladattava tiedosto',
      helpText: 'Jos välilehden nimi on tyhjä, käytetään ensimmäistä tiedostosta löydettyä välilehteä',
      sheetname: 'Välilehden nimi',
      submitExcelFile: 'Tuo',
      uploadFromFile: 'Tuo kysymykset tiedostosta',
      readError: 'Tiedoston luvussa tapahtui käsittelemätön virhe'
    },
    filteringOptions: 'Arviointipohjan näkyvyys ja käyttö',
    formDescription: 'Lisätiedot',
    formName: 'Pohjan nimi',
    answerDeleteThreshold: 'Vanhojen vastausten poiston aikaraja (kk)',
    showDeleteThreshold: 'Aseta vastausten poiston aikaraja',
    gradingScale: 'Arviointiasteikko',
    headingName: 'Otsikon nimi',
    heading: 'Otsikko',
    headings: 'Otsikot',
    minQualityPercent: 'Minimilaatuprosentti',
    maxQualityPercent: 'Tavoitearvosanan laatuprosentti',
    newHeading: 'Uusi otsikko',
    newQuestion: 'Lisää kysymys',
    newTitle: 'Uusi arviointipohja',
    percentageReportingNeedsAimedGrade: 'Tavoitearvosanaa ei ole valittu. Prosenttilukujen raportointi vaatii toimiakseen tavoitearvosanan',
    private: 'Asiakaskohtainen',
    public: 'Julkinen',
    questionDescription: 'Kysymyksen lisätiedot',
    questionName: 'Kysymys',
    questions: 'Kysymykset',
    questionWeight: 'Painotus',
    remarksFieldName1: 'Ensimmäisen selitekentän nimi',
    remarksFieldName1Default: 'Havainnot ja korjaavat toimenpiteet',
    remarksFieldName2: 'Toisen selitekentän nimi',
    remarksFieldName2Default: 'Vastuu',
    additionalInfoFieldName: 'Ensimmäisen lisätietokentän nimi',
    additionalInfoFieldNameDefault: 'Lisätietoja arvioinnista',
    infoClarificationFieldName: 'Toisen lisätietokentän nimi',
    infoClarificationFieldNameDefault: 'Arviointitietojen tarkennus',
    remarksFieldNames: 'Poikkeavat selitekenttien ja raportin otsikoiden nimet',
    remarksFieldNamesExplanation: 'Jätä allaolevat kentät tyhjiksi mikäli haluat käyttää järjestelmän oletustekstejä.' +
      ' Oletuksena näytetään selitekentät nimillä \'Havainnot ja korjaavat toimenpiteet\' ja \'Vastuu\', ' +
      'arvioinnin lisätietokentät nimillä \'Lisätietoja arvioinnista\' ja \'Arviointitietojen tarkennus\'' +
      ' sekä otsikkoina \'Laadunseurantaraportti\', \'Arviointikerran muutoshistoria\' ja \'Arvioitu asia\'',
    fieldOnlyUsedInSiteEvaluation: 'Käytettävissä vain laadunseurannassa',
    serviceTypes: 'Pohjalle sopivat palvelut',
    shouldHaveHeadings: 'Lomakkeessa pitää olla ainakin yksi osio',
    shouldHaveQuestions: 'Osiossa pitää olla ainakin yksi kysymys',
    siteSizes: 'Pohjalle sopivat kohteen koot',
    siteTypes: 'Pohjalle sopivat kohteen tyypit',
    untitledHeading: 'Nimeämätön otsikko',
    usedInSiteEvaluation: 'Lomake on käytettävissä laadunseurannassa',
    usedInPersonEvaluation: 'Lomakkeen käyttö henkilöarvioinnissa',
    visibilityInQualityAssurance: 'Arviointipohjan näkyvyys laadunseurannassa',
  },
  fiilissVisibility: {
    title: 'FiilISS-mittarin aukioloajat',
    year: 'Vuosi',
    selectYear: 'Valitse vuosi',
    selectStartDate: 'Valitse aloituspäivä',
    selectEndDate: 'Valitse lopetuspäivä',
    reset: 'Tyhjennä aikaväli',
    save: 'Avaa uusi kysely',
    update: 'Päivitä aukioloaika',
    delete: 'Poista kysely',
    selectedRange: 'Valittu aikaväli',
    existingRange: 'Aktiivisen kyselyn aikaväli',
    noExistingQuestionnaire: 'Ei aktiivista kyselyä'
  },
  formList: {
    deleteFormTooltip: 'Poista arviointipohja',
    editFormTooltip: 'Muokkaa arviointipohjaa',
    formDescription: 'Lisätiedot',
    formName: 'Nimi',
    newForm: 'Uusi arviointipohja',
    title: 'Arviointipohjat',
  },
  gradeReportingStyle: {
    name_and_number_value: 'Arvosanan nimi ja numeroarvo',
    name_only: 'Vain arvosanan nimi',
  },
  gradingScaleList: {
    defaultGrade: 'Vakioarvosana',
    deleteScaleTooltip: 'Poista asteikko',
    editScaleTooltip: 'Muokkaa arviointiasteikkoa',
    newScale: 'Uusi arviointiasteikko',
    scaleGrades: 'Arvosanat',
    scaleName: 'Nimi',
    title: 'Arviointiasteikot',
  },
  gradingScaleEditor: {
    changeFormGradingScales: {
      cancellation: {
        title: 'Asteikkojen vaihdot lomakkeille peruttu',
        body: 'Lomakkeita ei muokattu. Voit halutessasi edelleen tehdä asteikon vaihtoja lomakkeille asteikon muokkausnäkymässä.',
      },
    },
    chooseDefaultGrade: 'Valitse vakioarvosana',
    defaultGrade: 'Vakioarvosana',
    editScaleTitle: 'Muokkaa arviointiasteikkoa',
    formDescription: 'Kuvaus',
    formName: 'Nimi',
    formsUsingScale: 'Asteikkoa käyttävät lomakkeet',
    formListDividerEditingOld: 'Yllä asteikkoa tällä hetkellä käyttävät lomakkeet, alta voit valita muita lomakkeita käyttämään tätä asteikkoa.',
    formListDivider: 'Yllä pohjana olevaa asteikkoa käyttäneet lomakkeet, alta voit valita muita lomakkeita käyttämään uutta asteikkoa.',
    gradeColor: 'Arvosanan väri',
    gradeReportingStyle: 'Näytä raportilla',
    grades: 'Arvosanat',
    invalidColor: 'Ei väriä',
    newGrade: 'Lisää arvosana',
    newScaleTitle: 'Uusi arviointiasteikko',
    newScaleFromThis: 'Uusi arviointiasteikko tämän tiedoilla',
    noColor: 'Ei väriä',
    scaleName: 'Nimi',
    scaleNumericValue: 'Numeroarvo',
    saveScaleSuccess: 'Asteikko tallennettu',
    searchForForms: 'Rajaa lomakelistaa',
    shouldHaveManyGrades: 'Asteikossa tulisi olla ainakin kaksi arvosanaa',
  },
  lateEventsList: {
    editSelected: 'Muokka valittuja',
    title: 'Myöhässä olevat arviointikerrat',
  },
  lateEventsOperations: {
    cancelEvents: {
      cancellingReason: 'Valitse perumisen syy:',
      cancellingReasonDescription: 'Lisätietoja',
      confirmMessage: {
        one: 'Haluatko varmasti perua tämän arviointikerran?',
        other: 'Haluatko varmasti perua nämä %(count)s arviointikertaa?',
      },
      failure: {
        one: 'Arviontikerran peruminen ei onnistunut',
        other: 'Näiden %(count)s arviointikerran peruminen ei onnistunut ',
      },
      proceed: 'Peru arviointikerrat',
      progressMessage: 'Perutaan arviointikertoja',
      success: 'Arviointikerrat peruttu onnistuneesti',
      title: 'Peru valitut arviointikerrat',
    },
    error: 'Virhe',
  },
  loginForm: {
    downloadPrivacyPolicy: 'Lataa rekisteriseloste',
    emptyPassword: 'Salasanaa ei ole annettu',
    emptyUsername: 'Käyttäjätunnusta ei ole annettu',
    login: 'Kirjaudu sisään',
    loginWithAzureAd: 'Kirjaudu ISS-tilillä',
    loginAsExternalUser: 'Tai ulkoisena käyttäjänä',
    password: 'Salasana',
    title: 'Sisäänkirjautuminen',
    unknownError: 'Virhe kirjautumisessa',
    unknownSpecificError: 'Virhe kirjautumisessa: %(message)s',
    username: 'Käyttäjätunnus',
    wrongCredentials: 'Käyttäjätunnus tai salasana on väärä',
    expiredPassword: 'Salasanasi on vanhentunut. Voit vaihtaa salasanan palvelussa <>',
    credentialsExpired: 'Tunnus tai salasana vanhentunut',
    accountExpired: 'Kirjautuminen ei onnistunut: tili on vanhentunut',
    accountDisabled: 'Kirjautuminen ei onnistunut: tili on poissa käytöstä',
    accountLocked: 'Kirjautuminen ei onnistunut: tili on lukittu - yritä hetken kuluttua uudelleen',
    invalidUserInfo: 'Kirjautuminen ei valitettavasti onnistunut. Asiasta on lähetetty ilmoitus eteenpäin.',
    invalidRole: 'Kirjautuminen ei onnistunut: ei oikeutta kirjautua',
    unknownAadUser: 'Tuntematon käyttäjä',
    aadInteractionInProgress: 'Sisään- tai uloskirjautumisprosessi on kesken, sulje avoinna oleva dialogi',
    userCancelled: 'Käyttäjä keskeytti kirjautumisen',
  },
  loggedOut: {
    message: 'Uloskirjautuminen onnistui!'
  },
  navigation: {
    allActivations: 'Vastuukohteet',
    logout: 'Kirjaudu ulos',
    reports: 'Raportit',
    ownActivations: 'Omat vastuukohteet',
    title: 'ISS Laadunseuranta',
  },
  party: {
    hasNoEmail: 'Sähköpostia ei asetettu',
  },
  questionEditor: {
    backToList: 'Takaisin kysymyslistaan',
    questionNotFound: 'Kysymystä ei löytynyt!',
    removeGroup: 'Poista kysymysluokka',
    title: 'Muokkaa kysymysluokkia',
  },
  questionGroupEditor: {
    delete: 'Poista',
    deleteGroup: 'Poista kysymysluokka',
    doYouWantToDelete: 'Haluatko varmasti poistaa kysymysluokan?',
    newGroupTitle: 'Uusi kysymysluokka',
    editGroupTitle: 'Muokkaa kysymysluokkaa',
  },
  questionGroupList: {
    backToQuestionList: 'Takaisin kysymyslistaan',
    editGroupTooltip: 'Muokkaa kysymysluokkaa',
    newGroup: 'Uusi kysymysluokka',
    title: 'Muokkaa kysymysluokkia',
  },
  questionList: {
    doYouWantToRemove: 'Haluatko varmasti poistaa kysymysluokan kysymykseltä?',
    editQuestionGroupsTooltip: 'Muokkaa kysymysluokkia',
    editSelected: 'Muokkaa valittuja',
    modifyQuestionGroups: 'Muokkaa kysymysluokkia',
    removeGroup: 'Poista kysymysluokka',
    removeGroupTooltip: 'Poista kysymysluokka',
    title: 'Kysymysluokat',
  },
  questionOperations: {
    addGroup: {
      chooseQuestionGroup: 'Valitse kysymysluokka',
      confirmMessage: {
        one: 'Haluatko varmasti lisätä kysymysluokan tälle kysymykselle?',
        other: 'Haluatko varmasti lisätä kysymysluokan näille %(count)s kysymyksille?',
      },
      failure: {
        one: 'Kysymysluokan lisäys ei onnistunut seuraavalle kysymykselle',
        other: 'Kysymysluokan lisäys ei onnistunut seuraaville %(count)s kysymyksille ',
      },
      proceed: 'Lisää kysymysluokka',
      progressMessage: 'Lisätään kysymysluokkaa',
      questions: 'Kysymykset:',
      success: 'Kysymysluokka lisätty onnistuneesti',
      title: 'Lisää kysymysluokka valituille kysymyksille',
    },
    error: 'Virhe',
    removeGroup: {
      chooseQuestionGroup: 'Valitse kysymysluokka',
      confirmMessage: {
        one: 'Haluatko varmasti poistaa kysymysluokan tältä kysymykseltä?',
        other: 'Haluatko varmasti poistaa kysymysluokan näiltä %(count)s kysymyksiltä?',
      },
      failure: {
        one: 'Kysymysluokan poisto ei onnistunut seuraavalta kysymykseltä',
        other: 'Kysymysluokan poisto ei onnistunut seuraavilta %(count)s kysymyksiltä ',
      },
      proceed: 'Poista kysymysluokka',
      progressMessage: 'Poistetaan kysymysluokkaa',
      questions: 'Kysymykset:',
      success: 'Kysymysluokka poistettu onnistuneesti',
      title: 'Poista kysymysluokka valituilta kysymyksiltä',
    },
  },
  reports: {
    allActivations: 'Kaikki kuukauden aikana aktiivisena olleet aktivoinnit',
    allActivationsByServiceCategory: 'Kaikki aktivoinnit palveluryhmittäin',
    finishedEvents: 'Tehdyt laadunseurantakierrokset',
    fromPeriod: 'Ajalta',
    newActivations: 'Uudet aktivoinnit',
    noData: 'Tietoja ei löytynyt',
    personEvaluations: 'Tehdyt henkilöarvioinnit',
    securityObservations: 'Tehdyt turvallisuushavainnot',
    title: 'Raportit',
    workQuoteDownload: 'Lataa kaikki tarjoukset ja havainnot',
    workQuotes: 'Tehdyt tarjoukset ja havainnot',
    workQuoteTypes: {
      all: 'Yhteensä',
      OFFER: 'Tarjous',
      QUOTE: 'Kustannusarvio',
      PTS_OBSERVATION: 'PTS-havainto',
      WORK_PROPOSAL: 'Toimenpide-ehdotus',
      FIXED_PRICE: 'Kiinteähintainen tarjous',
    },
  },
  reviewEvaluationPage: {
    reviewDone: 'Arviointi katselmoitu',
    reviewEvaluation: 'Aloita katselmointi',
    stateError: 'Arvioinnin tila ei ole "valmis katselmoitavaksi"',
  },
  systemStatusNotifications: {
    addGeneralNotification: 'Lisää yleinen tiedote',
    addNotification: 'Lisää vikatilailmoitus',
    editGeneralNotification: 'Muokkaa yleistä tiedotetta',
    editNotification: 'Muokkaa vikatilailmoitusta',
    newDescription: 'Uusi vikatilaviesti',
    newGeneralDescription: 'Uusi yleinen tiedote',
    otherSystems: 'Muut järjestelmät',
    removeGeneralNotification: 'Poista yleinen tiedote',
    removeNotification: 'Poista vikatila',
    title: 'Järjestelmän ilmoitukset',
  },
  validation: {
    chooseAtLeastOne: 'Valitse ainakin yksi',
    chooseOne: 'Valitse yksi',
    shouldBeHexColor: 'Syötä väriarvo heksadesimaalina muodossa 123abf',
    shouldBeInteger: 'Syötä kokonaisluku',
    shouldBeNumber: 'Syötä numeroarvo',
    shouldNotBeEmpty: 'Ei saa olla tyhjä',
  },
  widgets: {
    GradingScaleReportingInfo: {
      aimedGradeIsHilighted: 'Tavoitearvosana on korostettu.',
      aimedGradeIsLowest: 'Laatuprosenttia ei pystytä laskemaan. Tavoitearvosanalla ja pienimmällä arvosanalla pitää olla eri numeroarvo.',
      explanation: 'Alla esimerkki raporttiin päätyvistä luvuista eri arvosanoille.',
      grade: 'Arvosana',
      noAimedGrade: 'Valitse tavoitearvosana',
      noMaxQualityPercent: 'Syötä tavoitearvosanan laatuprosentti',
      noMinQualityPercent: 'Syötä minimilaatuprosentti',
      percent: 'Prosenttiluku',
      value: 'Numeroarvo',
    },
    multiDateInput: {
      writeDateHereOrChooseFromCalendar: 'kirjoita päivämäärä tähän tai valitse kalenterista',
    }
  },
  other: {
    extUsersMenuTitle: 'Ulkoiset käyttäjät',
    siteInfoMenuTitle: 'Kohdekansiot'
  }
};

export function getFormatter(lang, options) {
  if (!Intl) return {format: num => num};
  return new Intl.NumberFormat(lang, options);
}

export function formatNumber(number, options /* = {style: "decimal"} */) {
  return getFormatter("fi", options).format(number);
}

export function formatPercent(percent) {
  return formatNumber(percent/100, {style: 'percent', maximumFractionDigits: 2});
}

counterpart.setLocale("fi");
counterpart.registerTranslations('fi', strings);
counterpart.setMissingEntryGenerator(function(key) {
  if (window.console) window.console.warn("Missing translation for key "+key);
  return "⚠ Translation missing: "+key+" ⚠";
});

export const translate = counterpart;



// WEBPACK FOOTER //
// ./modules/issFrontend/strings.js